import videojs from 'video.js';
import Overlay, { OverlayPosition } from '../../components/overlay.js';
import ModalDialog from '../../components/modal-dialog.js';

/**
 * Shows a short string of plain text in a basic modal.
 * @memberof MediasitePlayer#
 * @param {string} message
 * @param {Object} [options]
 * @param {boolean} [options.uncloseable]
 * @returns {videojs.ModalDialog}
 * @example
 * player.showMessage('This message shows in a nicely-styled modal dialog.');
 */
function showMessage(message, options = {}) {
    if (typeof message === 'string') {
        const player = this;
        const { url, classes, ...rest } = options;
        
        const overlay = new Overlay(player, {
            text: message,
            url,
            position: OverlayPosition.Center,
            className: classes ? classes.join(' ') : ''
        });

        if (classes) {
            //When the modal opens, it slides in.  The styling added gets a bit jumpy until the modal is all the way open.
            //Hide the overlay until the modal is all the way open.
            overlay.el().style.display = 'none';
            setTimeout(function () {
                overlay.el().style.display = 'block';
            }, 250);
        }

        const modal = new ModalDialog(player, {
            text: message,
            content: [overlay.el()],
            solidBackground: false,
            ...rest
        });

        modal.addClass("mediasite-player__show-message-modal");
        player.addChild(modal);
        modal.open();
        return modal;
    }
}

export default showMessage;
